"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var HtmlCell = function HtmlCell(_ref) {
  var cell = _ref.cell,
    page = _ref.page,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer,
    intl = _ref.intl,
    defaultLanguage = _ref.defaultLanguage,
    project = _ref.project,
    logEvent = _ref.logEvent;
  return /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: cell.html
    }
  });
};
var _default = exports.default = HtmlCell;